var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset",class:_vm.computedClass},[_vm._v(" "+_vm._s(_vm.status)+" "),(_vm.status === 'Retrying' && _vm.posRetryCount > 0)?_c('span',{staticClass:"ml-1"},[_vm._v(" "+_vm._s(' x' + _vm.posRetryCount)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }